import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { Fg6InterfaceEscalation } from '../data-end-channel-settings-dialog/interfaces/fg6interface';
import { EscalationLevel, getEscalationLevelString, getEscalationLevelSelect } from 'src/app/project/shared/enums/escalation-level';

@Component({
  selector: 'avs-digital-input-engine-parameter-settings-dialog',
  standalone: false,
  templateUrl: './digital-input-engine-parameter-settings-dialog.component.html',
  styleUrl: './digital-input-engine-parameter-settings-dialog.component.css'
})
export class DigitalInputEngineParameterSettingsDialogComponent {
  public jsonObj?: any;

  public guid?: string;
  public type?: string;
  public fg6ObjEscalation?: Fg6InterfaceEscalation;
  public projectId?: number;
  public information: string = ''
  public isReadonly: boolean = false;
  /*   public escalationLevelsString  */

  escalationLevelActive: number = 0;
  escalationLevelNotActive: number = 0;
  escalationLevelOptions = getEscalationLevelSelect();

  constructor(
    private dialogRef: MatDialogRef<DigitalInputEngineParameterSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectService
  ) { }

  public ngOnInit(): void {
    this.isReadonly = !!this.data.readonly;
    this.jsonObj = JSON.parse(this.data.data)

    if (this.data.fg === 6) { this.fg6ObjEscalation = this.jsonObj?.EngineParameter as Fg6InterfaceEscalation; }
    this.guid = this.data.guid;
    this.type = this.data.type;
    this.projectId = this.data.projectId;
    this.escalationLevelActive = this.fg6ObjEscalation?.EscalationLevelActive ?? EscalationLevel.S0;
    this.escalationLevelNotActive = this.fg6ObjEscalation?.EscalationLevelNotActive ?? EscalationLevel.S0;
  }


  public onNoClick(): void {
    this.dialogRef.close();
  }

  public onSubmitClick(): void {
    let escalationLevelActive = this.escalationLevelActive;
    let escalationLevelNotActive = this.escalationLevelNotActive;
    let createdEngineParams: Fg6InterfaceEscalation = {
      EscalationLevelActive: escalationLevelActive,
      EscalationLevelNotActive: escalationLevelNotActive
    };
    this.dialogRef.close({ settings: createdEngineParams, fg: 6, type: this.type });
  }


  public onResetToDefaultClick(): void {
    this.escalationLevelActive = EscalationLevel.S0;
    this.escalationLevelNotActive = EscalationLevel.S0;

    let fallbackEngineParams: Fg6InterfaceEscalation = {
      EscalationLevelActive: this.escalationLevelActive,
      EscalationLevelNotActive: this.escalationLevelNotActive
    };
    this.dialogRef.close({ settings: fallbackEngineParams, fg: 6, type: this.type });
  }

}
